import React from "react";

import CloseIcon from "@uui/XClose";

import { Box, Card, IconButton, Modal, Stack } from "@mui/material";

const cardStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 398,
  bgcolor: "background.paper",
  boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.1)",
  p: 0,
  borderRadius: "4px",
  outline: "none",
};

export interface ImagePopupCtaProps {
  open: boolean;
  imageSrc: string;
  children: React.ReactNode;
  onClose?: () => void;
}

const ImagePopupCta = ({
  open,
  imageSrc,
  onClose,
  children,
}: ImagePopupCtaProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Card sx={cardStyle}>
        <Box
          sx={{
            width: "100%",
            height: "200px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <img
            src={imageSrc}
            alt="imageCta"
            style={{ width: "100%", display: "block" }}
          />
          {onClose && (
            <IconButton
              sx={{
                zIndex: 2,
                position: "absolute",
                top: "24px",
                right: "24px",
                background: "rgba(255,255,255,0.4)",
                backdropFilter: "blur(1px)",
              }}
              onClick={onClose}
            >
              <CloseIcon sx={{ fill: "#515151" }} />
            </IconButton>
          )}
        </Box>
        <Stack sx={{ padding: "16px 24px" }}>{children}</Stack>
      </Card>
    </Modal>
  );
};

export default ImagePopupCta;
